module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_HERBALFASTINGTEA.4db8e944.png";